module.exports = __webpack_public_path__ + "static/media/st-bill-img-pay.a7b5023c.svg";